import { useMutation, useQueryClient } from '@tanstack/react-query'
import { MCP_OAUTH_CONNECTIONS_QUERY_KEY } from './useMcpOauthConnections'
import { revokeMcpOauthConnection } from '@/lib/api/features/mcp-oauth-connections'

export function useRevokeMcpOauthConnection() {
  const queryClient = useQueryClient()
  return useMutation<void, Error, string>({
    mutationFn: revokeMcpOauthConnection,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: MCP_OAUTH_CONNECTIONS_QUERY_KEY,
      })
    },
  })
}
